import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Checkbox, TextField, InputAdornment, IconButton } from '@mui/material'

import './styles/index.css'
import { UserContext } from '../../contexts'
import { numberWithCommas } from '../../utils'
import PlusIcon from '../../assets/icons/plus-icon.svg'
import { CustomerCompany, FormError } from '../../types'
import TrashIcon from '../../assets/icons/trash-icon.svg'
import FilterIcon from '../../assets/icons/filter-icon.svg'
import SearchIcon from '../../assets/icons/search-icon.svg'
import { baseButtonTextWhiteBg, baseButtonWarning, textFieldWhiteBg } from '../../theme/custom-styles'

export const ActionsBar = ({
  errors,
  userTypeName,
  showDeleteButton,
  generalActionChecked,
  handleDialogOpenState,
  customerCompaniesData,
  disableActionOfButtons,
  handleClearSearchInput,
  customerCompanyToSearch,
  handleOpenAddClientModal,
  handleSetCustomerCompanyToSearch,
  handleToggleGeneralActionChecked,
  handleOpenCreateBankingPartnerTestModal
}: {
  errors: FormError
  userTypeName: string
  showDeleteButton: boolean
  generalActionChecked: boolean
  customerCompanyToSearch: string
  disableActionOfButtons?: boolean
  handleClearSearchInput: () => void
  handleOpenAddClientModal: () => void
  customerCompaniesData: Array<CustomerCompany>
  handleDialogOpenState: (actionToDo: string) => void
  handleOpenCreateBankingPartnerTestModal: () => void
  handleToggleGeneralActionChecked: (checked: boolean) => void
  handleSetCustomerCompanyToSearch: (customerCompanyToSearchData: string, showError: boolean) => void
}) => {
  const { t } = useTranslation(['common'])
  const { userSession } = useContext(UserContext)

  return (
    <div className="actions-bar-container customer-companies-management-actions-bar-container">
      <div className="actions-bar-left">
        <div className="actions-bar-check-option">
          {(!userSession?.subRole ||
            (userSession?.subRole && userSession?.subRole !== 'payments-specialist' && userSession?.subRole !== 'reconciliation-specialist' && userSession?.subRole !== 'compliance-specialist')) && (
            <Checkbox
              checked={customerCompaniesData.length === 0 ? false : generalActionChecked === true ? true : false}
              disabled={false}
              onChange={(event) => handleToggleGeneralActionChecked(event.target.checked)}
            />
          )}
          {customerCompaniesData.length === 0 ? (
            <div className="actions-bar-check-option-text">{t('usersActionBar.emptyListMessage', { userTypeName })}</div>
          ) : (
            <div
              className="users-management-actions-bar-check-option-text"
              onClick={() => {
                const checkedStateUpdated = generalActionChecked === true ? false : true
                handleToggleGeneralActionChecked(checkedStateUpdated)
              }}
            >
              {`${numberWithCommas(customerCompaniesData.length)} ${customerCompaniesData.length === 1 ? userTypeName : userTypeName.slice(-1) === 'y' ? `${userTypeName.slice(0, -1)}ies` : `${userTypeName}s`} `}
            </div>
          )}
        </div>
        <div className="users-management-actions-bar-button-action-container">
          {userSession?.role === 'super-admin' && (
            <>
              {customerCompaniesData.length > 0 && showDeleteButton ? (
                <Button
                  fullWidth
                  variant="text"
                  sx={baseButtonWarning}
                  startIcon={
                    <img
                      src={TrashIcon}
                      alt="trash-icon"
                    />
                  }
                  className="users-management-actions-bar-button-action"
                  onClick={() => {
                    handleDialogOpenState('delete')
                  }}
                >
                  <div className="users-management-actions-bar-button-action-text">
                    {t('usersActionBar.buttonsTexts.deleteUser', {
                      userTypeName: customerCompaniesData.length === 1 ? userTypeName : userTypeName.slice(-1) === 'y' ? `${userTypeName.slice(0, -1)}ies` : `${userTypeName}s`
                    })}
                  </div>
                </Button>
              ) : (
                <>
                  {(!userSession?.subRole || (userSession?.subRole && userSession?.subRole !== 'payments-specialist' && userSession?.subRole !== 'reconciliation-specialist')) && (
                    <Button
                      fullWidth
                      variant="text"
                      sx={baseButtonTextWhiteBg}
                      startIcon={
                        <img
                          src={PlusIcon}
                          alt="plus-icon"
                        />
                      }
                      disabled={disableActionOfButtons}
                      className="users-management-actions-bar-button-action"
                      onClick={() => {
                        handleOpenAddClientModal()
                        handleSetCustomerCompanyToSearch('', false)
                      }}
                    >
                      <div className="users-management-actions-bar-button-action-text">{t('usersActionBar.buttonsTexts.addUser', { userTypeName })}</div>
                    </Button>
                  )}
                  {userSession?.username === 'lcanogiraldo@gmail.com' && (
                    <Button
                      fullWidth
                      variant="text"
                      sx={baseButtonTextWhiteBg}
                      disabled={disableActionOfButtons}
                      className="users-management-actions-bar-button-action"
                      onClick={() => {
                        handleOpenCreateBankingPartnerTestModal()
                      }}
                    >
                      <div className="users-management-actions-bar-button-action-text">Hacer test de rieles</div>
                    </Button>
                  )}
                </>
              )}
            </>
          )}
          {userSession?.username !== 'lcanogiraldo@gmail.com' && (
            <div
              style={{ cursor: 'pointer' }}
              className="filter-button-container"
              onClick={() => console.log('entro')}
            >
              {/* !fromDateToSearch && !toDateToSearch && !beneficiaryToSearch ? (
                    <> */}
              <img
                src={FilterIcon}
                alt="filter-icon"
              />
              <div className="filter-button-text">{t('actionsBar.filter', { ns: 'customer-details-management' })}</div>
              {/* </>
                  ) : (
                    <>
                      <div className="filter-button-text">
                        {beneficiaryToSearch && !fromDateToSearch && !toDateToSearch
                          ? beneficiaryToSearch.split('-')[1]
                          : (fromDateToSearch || toDateToSearch) && !beneficiaryToSearch
                          ? `${format(addHours(new Date(fromDateToSearch as Date), 5), 'dd/MM/yyyy')} - ${format(addHours(new Date(toDateToSearch as Date), 5), 'dd/MM/yyyy')}`
                          : ''}
                      </div>
                      <div
                        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                        onClick={() => {
                          setToDateToSearch(null)
                          setFromDateToSearch(null)
                          setBeneficiaryToSearch('')
                          setOpenPaymentFiltersModal(false)
                          setCustomerCompanyPaymentToSearch('')
                          handleSetCustomerCompanyPaymentToSearch('', false)
                        }}
                      >
                        <img
                          src={CancelIcon}
                          alt="cancel-icon"
                        />
                      </div>
                    </>
                  ) */}
            </div>
          )}
        </div>
      </div>
      <div className="actions-bar-right">
        <TextField
          fullWidth
          variant="standard"
          sx={textFieldWhiteBg}
          label={t('usersActionBar.searchFieldText', { userTypeName })}
          value={customerCompanyToSearch}
          error={!!errors.customerCompanyToSearch}
          helperText={errors.customerCompanyToSearch}
          className="users-management-actions-bar-search-input"
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              event.preventDefault()
              handleSetCustomerCompanyToSearch(customerCompanyToSearch, true)
            }
          }}
          onChange={(event) => {
            handleSetCustomerCompanyToSearch(event.target.value, true)
          }}
          onBlur={() => {
            if (customerCompanyToSearch === '') handleClearSearchInput()
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  edge="end"
                  aria-label="toggle password visibility"
                  sx={{ color: '#107569', right: '10px', bottom: '3px' }}
                >
                  <img
                    src={SearchIcon}
                    alt="search-icon"
                  />
                </IconButton>
              </InputAdornment>
            )
          }}
        />
      </div>
    </div>
  )
}
